import { DeleteIcon, MineIcon, PlusIcon } from "assets/icons";

function FoodCardList({ data }) {
  return (
    <div className="w-full flex items-center">
      <div
        style={{ backgroundImage: `url(${data.image})` }}
        className="bgImage !h-[70px] !w-[70px] rounded-[10px] mr-6"
      />
      <div className="flex-1 flex flex-col">
        <div className="text-[#202020] text-sm font-medium mb-1">
          {data.label}
        </div>
        <div className="flex items-center">
          <button className="h-6 w-6 border-[1px] border-primary-700 rounded-[4px] flex items-center justify-center">
            <MineIcon />
          </button>
          <div className="text-sm font-semibold text-[#202020] px-4">2</div>
          <button className="h-6 w-6 border-[1px] border-primary-700 rounded-[4px] flex items-center justify-center">
            <PlusIcon />
          </button>
        </div>
      </div>
      <div className="flex flex-col">
        <button className="h-5 w-5 text-primary-700 mb-4">
          <DeleteIcon />
        </button>
        <div className="text-lg font-medium text-[#0A0D13]">{`RM${data.price}`}</div>
      </div>
    </div>
  );
}

export default FoodCardList;
